var scope_0 = require('/vercel/path0/slides/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad81eb68c92dd95076261d6440bbcd8a.js').default;export default
        Object.assign({}, scope_0 )
    